/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Currency } from './';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
} from './';
import type { ExpenseCategory } from './';
import {
    ExpenseCategoryFromJSON,
    ExpenseCategoryFromJSONTyped,
    ExpenseCategoryToJSON,
} from './';

/**
 * 
 * @export
 * @interface ExpenseReceiptResponse
 */
export interface ExpenseReceiptResponse {
    /**
     * 
     * @type {string}
     * @memberof ExpenseReceiptResponse
     */
    analyseStatus: ExpenseReceiptResponseAnalyseStatusEnum;
    /**
     * 
     * @type {ExpenseCategory}
     * @memberof ExpenseReceiptResponse
     */
    category?: ExpenseCategory;
    /**
     * 
     * @type {Date}
     * @memberof ExpenseReceiptResponse
     */
    purchaseDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof ExpenseReceiptResponse
     */
    amountWithoutTaxes?: number;
    /**
     * 
     * @type {number}
     * @memberof ExpenseReceiptResponse
     */
    taxAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof ExpenseReceiptResponse
     */
    amountWithTaxes?: number;
    /**
     * 
     * @type {string}
     * @memberof ExpenseReceiptResponse
     */
    supplier?: string;
    /**
     * 
     * @type {Currency}
     * @memberof ExpenseReceiptResponse
     */
    currency?: Currency;
}


/**
 * @export
 */
export const ExpenseReceiptResponseAnalyseStatusEnum = {
    Completed: 'COMPLETED',
    Partial: 'PARTIAL',
    Empty: 'EMPTY'
} as const;
export type ExpenseReceiptResponseAnalyseStatusEnum = typeof ExpenseReceiptResponseAnalyseStatusEnum[keyof typeof ExpenseReceiptResponseAnalyseStatusEnum];


/**
 * Check if a given object implements the ExpenseReceiptResponse interface.
 */
export function instanceOfExpenseReceiptResponse(value: object): value is ExpenseReceiptResponse {
    if (!('analyseStatus' in value) || value['analyseStatus'] === undefined) return false;
    return true;
}

export function ExpenseReceiptResponseFromJSON(json: any): ExpenseReceiptResponse {
    return ExpenseReceiptResponseFromJSONTyped(json, false);
}

export function ExpenseReceiptResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExpenseReceiptResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'analyseStatus': json['analyseStatus'],
        'category': json['category'] == null ? undefined : ExpenseCategoryFromJSON(json['category']),
        'purchaseDate': json['purchaseDate'] == null ? undefined : (new Date(json['purchaseDate'])),
        'amountWithoutTaxes': json['amountWithoutTaxes'] == null ? undefined : json['amountWithoutTaxes'],
        'taxAmount': json['taxAmount'] == null ? undefined : json['taxAmount'],
        'amountWithTaxes': json['amountWithTaxes'] == null ? undefined : json['amountWithTaxes'],
        'supplier': json['supplier'] == null ? undefined : json['supplier'],
        'currency': json['currency'] == null ? undefined : CurrencyFromJSON(json['currency']),
    };
}

export function ExpenseReceiptResponseToJSON(value?: ExpenseReceiptResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'analyseStatus': value['analyseStatus'],
        'category': ExpenseCategoryToJSON(value['category']),
        'purchaseDate': value['purchaseDate'] == null ? undefined : ((value['purchaseDate']).toISOString().substring(0,10)),
        'amountWithoutTaxes': value['amountWithoutTaxes'],
        'taxAmount': value['taxAmount'],
        'amountWithTaxes': value['amountWithTaxes'],
        'supplier': value['supplier'],
        'currency': CurrencyToJSON(value['currency']),
    };
}

